import { render, staticRenderFns } from "./TickersCarousel.vue?vue&type=template&id=0a60f0f4&scoped=true"
import script from "./TickersCarousel.vue?vue&type=script&lang=js"
export * from "./TickersCarousel.vue?vue&type=script&lang=js"
import style0 from "./TickersCarousel.vue?vue&type=style&index=0&id=0a60f0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60f0f4",
  null
  
)

export default component.exports